<template>
  <div class="list-page-container">
    <div class="breadcrumbs">维保服务</div>
    <div class="header-button">
      <el-row :gutter="20" class="stats-cards">
        <el-col :xs="24" :sm="8">
          <div class="stat-card stat-card--pending">
            <div class="stat-card__content">
              <div class="stat-card__label">待处理</div>
              <div class="stat-card__count">{{ overview.waiting }}</div>
            </div>
            <div class="stat-card__icon">
              <i class="el-icon-time"></i>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="8">
          <div class="stat-card stat-card--processing">
            <div class="stat-card__content">
              <div class="stat-card__label">处理中</div>
              <div class="stat-card__count">{{ overview.in_progress }}</div>
            </div>
            <div class="stat-card__icon">
              <i class="el-icon-warning-outline"></i>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="8">
          <div class="stat-card stat-card--completed">
            <div class="stat-card__content">
              <div class="stat-card__label">已完成</div>
              <div class="stat-card__count">{{ overview.completed }}</div>
            </div>
            <div class="stat-card__icon">
              <i class="el-icon-circle-check"></i>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="list-page-wrap">
      <!-- 顶部操作栏 -->
      <div class="list-page-heaser">
        <el-form ref="searchForm" class="header-search" :model="searchData" @keydown.enter.native="searchSubmit">
          <el-form-item label="客户名称" prop="customer_name">
            <el-input v-model="searchData.customer_name" clearable></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="company">
            <el-input v-model="searchData.company" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="product_name">
            <el-input v-model="searchData.product_name" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品序列号" prop="product_sn">
            <el-input v-model="searchData.product_sn" clearable></el-input>
          </el-form-item>
          <el-form-item label="工单号" prop="ticket_no">
            <el-input v-model="searchData.ticket_no" clearable></el-input>
          </el-form-item>
          <el-form-item label="维保状态" prop="status">
            <el-select v-model="searchData.status" placeholder="请选择">
              <el-option v-for="item in dataDict.STATUS" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维保类别" prop="type">
            <el-select v-model="searchData.type" placeholder="请选择">
              <el-option v-for="item in typeList" :key="item.label" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" icon="el-icon-search" @click="searchSubmit()">查询</el-button>
            <el-button @click="resetSearch()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 列表数据 -->
      <div class="list-page-table">
        <custom-table ref="customTableRef" :data="tableData" :columns="columns" :pagination="pagination"
          :height="tableHeight" row-key="seed_id" @sort-change="handleSortChange"
          @selection-change="handleSelectionChange" @current-page-change="handleCurrentChange"
          @size-change="handleSizeChange">
          <!-- 客户栏 -->
          <template #customer_name="{ row }">
            <span class="actions-btn">
              <div class="customer-info">
                <span class="customer-name">{{ row.customer_name }}</span>
                <span class="customer-company">{{ row.company }}</span>
                <span class="customer-mobile">{{ row.mobile }}</span>
              </div>
            </span>
          </template>
          <!-- 提交时间 -->
          <template #created_at="{ row }">
            {{ formatDateTime(row.created_at) }}
          </template>
          <!-- 状态栏 -->
          <template #status="{ row }">
            <el-tag :type="getTagType(row.status)" effect="plain">
              <i :class="getIconClass(row.status)"></i>
              {{ row.status_text }}
            </el-tag>
          </template>
          <!-- 操作栏 -->
          <template #actions="{ row }">
            <span class="actions-btn">
              <el-button type="text" icon="el-icon-view" class="view-btn" @click="showDetail(row)">查看详情</el-button>
            </span>
          </template>
        </custom-table>
      </div>
    </div>
    <el-dialog :title="addMaintenanceTitle" :append-to-body="true" :close-on-click-modal="false"
      :visible.sync="addMaintenanceVisible" @closed="closeAddMaintenanceDialog()">
      <el-form ref="addMaintenanceForm" :model="addMaintenanceData" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="detail-label">客户姓名</span>
              <span class="detail-value">{{ addMaintenanceData.customer_name }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="detail-label">公司名称</span>
              <span class="detail-value">{{ addMaintenanceData.company }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="detail-label">联系电话</span>
              <span class="detail-value">{{ addMaintenanceData.mobile }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="detail-label">提交时间</span>
              <span class="detail-value">{{ formatDateTime(addMaintenanceData.created_at) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="detail-label">地址</span>
              <span class="detail-value">{{ addMaintenanceData.address }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="detail-label">维保工单号</span>
              <span class="detail-value">{{ addMaintenanceData.ticket_no }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="detail-label">产品名称</span>
              <span class="detail-value">{{ addMaintenanceData.product_name }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="detail-label">产品序列号</span>
              <span class="detail-value">{{ addMaintenanceData.product_sn }}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="detail-item">
              <span class="detail-label">问题描述</span>
              <span class="detail-value">{{ addMaintenanceData.description }}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="detail-item">
              <span class="detail-label">处理备注</span>
              <el-input type="textarea" v-model="addMaintenanceData.comment" placeholder="输入处理备注..." rows="3" />
            </div>
          </el-col>
          <el-col :span="24">
            <div class="detail-image">
              <el-image v-for="img in addMaintenanceData.image" :key="img"
                style="width: 90px; height: 90px;margin-right: 20px;" :src="`${imgUrl}${img}`"
                :preview-src-list="[`${imgUrl}${img}`]" fit="cover">
              </el-image>
              <el-image v-if="addMaintenanceData.image?.length === 0" src="" style="width: 90px; height: 90px">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="detail-item">
              <span class="detail-label">更新状态</span>
              <div class="status-btn-group">
                <el-button type="primary" plain :class="{ 'active': addMaintenanceData.status === 1 }"
                  @click="addMaintenanceData.status = 1">
                  待处理
                </el-button>
                <el-button type="primary" plain :class="{ 'active': addMaintenanceData.status === 2 }"
                  @click="addMaintenanceData.status = 2">
                  处理中
                </el-button>
                <el-button type="primary" plain :class="{ 'active': addMaintenanceData.status === 3 }"
                  @click="addMaintenanceData.status = 3">
                  已完成
                </el-button>
              </div>
            </div>
          </el-col>
          <el-col :span="24">
            <el-form-item class="text-right">
              <el-button @click="addMaintenanceVisible = false">取消</el-button>
              <el-button type="success" @click="addMaintenanceSubmit()">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/api'
import listMixin from '@/mixins/listMixin'
import CustomTable from '@/components/custom-table.vue'
import * as DICT from '@/utils/dict/fieldDictionary'

export default {
  name: 'Maintenance',
  mixins: [listMixin],
  components: {
    CustomTable
  },
  data() {
    return {
      dataDict: DICT,
      typeList: [],
      overview: {},
      imgUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}`,
      addMaintenanceTitle: '维保请求详情',
      addMaintenanceVisible: false,
      addMaintenanceData: {
        customer_name: '',
        company: '',
        mobile: '',
        created_at: '',
        address: '',
        product_name: '',
        product_sn: '',
        ticket_no: '',
        description: '',
        comment: '',
        status: ''
      },
      addMaintenanceRules: {
      },
      // 列表相关数据
      searchData: {
        customer_name: '',
        company: '',
        product_name: '',
        product_sn: '',
        ticket_no: '',
        status: null,
        type: null
      },
      columns: [
        { label: '客户信息', prop: 'customer_name', width: '260', fixed: 'left' },
        { label: '产品名称', prop: 'product_name', width: '240' },
        { label: '产品序列号', prop: 'product_sn', width: '240' },
        { label: '维保工单号', prop: 'ticket_no', width: '240' },
        { label: '问题描述', prop: 'description', width: '400' },
        { label: '提交时间', prop: 'created_at', width: '240' },
        { label: '状态', prop: 'status', width: '140' },
        { label: '操作', prop: 'actions', width: '140', align: 'center', fixed: 'right' }
      ],
      queryListApi: apis.QUERY_MAINTENANCE_LIST
    }
  },
  mounted() {
    this.queryType()
    this.queryOverview()
  },
  methods: {
    addMaintenanceSubmit() {
      this.$refs.addMaintenanceForm.validate((valid) => {
        if (valid) {
          const request = {
            url: '/api/v1/admin/maintenances/' + this.addMaintenanceData.id,
            method: 'put',
            disableSuccessMsg: true,
            disableErrorMsg: false,
            params: {
              comment: this.addMaintenanceData.comment,
              status: this.addMaintenanceData.status
            }
          }
          this.$request(request)
            .asyncThen(
              (resp) => {
                if (resp.rst === 200) {
                  this.queryListData()
                  this.addMaintenanceVisible = false
                }
              },
              (err) => {
                console.error(err)
              }
            )
            .asyncErrorCatch((err) => {
              console.error('额外错误处理:', err)
            })
        } else {
          return false
        }
      })
    },
    showDetail(row) {
      console.log('编辑行：', row)
      this.addMaintenanceVisible = true
      // 映射行数据到对话框表单，并自动选中对应状态按钮
      this.addMaintenanceData = {
        id: row.id,
        customer_name: row.customer_name,
        company: row.company,
        mobile: row.mobile,
        created_at: row.created_at,
        address: row.address,
        product_name: row.product_name,
        product_sn: row.product_sn,
        ticket_no: row.ticket_no,
        description: row.description,
        image: row.image,
        comment: row.comment,
        status: row.status
      }
    },
    closeAddMaintenanceDialog() {
      this.addMaintenanceData = {
        id: '',
        customer_name: '',
        company: '',
        mobile: '',
        created_at: '',
        address: '',
        product_name: '',
        product_sn: '',
        ticket_no: '',
        description: '',
        image: '',
        comment: '',
        status: ''
      }
      this.$nextTick(() => {
        this.$refs.addMaintenanceForm.clearValidate()
      })
    },
    formatDateTime(timestamp) {
      if (!timestamp) return ''
      // 注意：你的数据是10位秒级时间戳，需要乘以1000转换成毫秒
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    getTagType(status) {
      switch (status) {
        case 1: return 'info'
        case 2: return 'primary'
        case 3: return 'success'
        default: return ''
      }
    },
    getIconClass(status) {
      switch (status) {
        case 1: return 'el-icon-time'
        case 2: return 'el-icon-warning-outline'
        case 3: return 'el-icon-circle-check'
        default: return ''
      }
    },
    queryType() {
      this.typeList = []
      const request = {
        ...apis.QUERY_MAINTENANCE_TYPE,
        params: {
        }
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.typeList = resp.data
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    queryOverview() {
      this.overview = []
      const request = {
        ...apis.QUERY_MAINTENANCE_OVERVIEW,
        params: {
        }
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.overview = resp.data
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    }
  }
}
</script>

<style scoped>
.admin-layout .admin-main .list-page-container .header-button {
  background-color: #f5f5f5;
  margin-bottom: 0px;
}

/* 统计卡片样式 */

.stat-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  background-color: #fff;
}

.stat-card__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-card__label {
  font-size: 16px;
  color: #6A7282;
  font-weight: 400;
  margin-bottom: 4px;
}

.stat-card__count {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
  color: #101828;
}

.stat-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 20%;
  font-size: 24px;
}

/* 卡片颜色主题（独立样式，便于修改） */

.stat-card--pending .stat-card__icon {
  background-color: #FFEDD4;
  color: #F54900;
}

.stat-card--processing .stat-card__icon {
  background-color: #DBEAFE;
  color: #155DFC;
}

.stat-card--completed .stat-card__icon {
  background-color: #DCFCE7;
  color: #00A63E;
}

/* 客户信息样式 */
.customer-info {
  display: flex;
  flex-direction: column;
  line-height: 1.4;
}

.customer-name {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 3px;
  color: #101828;
}

.customer-company,
.customer-phone {
  font-size: 16px;
  font-weight: 400;
  color: #6A7282;
}

/* 操作按钮样式 */
.view-btn {
  color: #4299e1;
  padding: 10px;
}

.view-btn:hover {
  color: #2563eb;
  background-color: transparent;
}

/* 状态按钮组样式 */
.status-btn-group {
  display: flex;
  gap: 10px;
}

.status-btn-group .el-button {
  min-width: 100px;
}

.status-btn-group .el-button.active {
  background-color: #409EFF;
  color: #fff;
  border-color: #409EFF;
}

.maintenance-detail {
  width: 100%;
}

.detail-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.detail-image {
  display: flex;
  margin-bottom: 20px;
}

.detail-label {
  display: inline-block;
  width: 80px;
  color: #606266;
  box-sizing: border-box;
}

.detail-value {
  color: #303133;
}

.dialog-footer {
  text-align: right;
}

.el-tag--plain.el-tag--info {
  background-color: #fff;
  color: #909399;
}

.el-tag--plain {
  background-color: #2B7FFF;
  color: #fff;
}

.el-tag--plain.el-tag--success {
  background-color: #00C950;
  color: #fff;
}
</style>
